type NoticeAlertProps = {
    className?: string;
};

const NoticeAlert = ({ className }: NoticeAlertProps) => (
    <svg width="1em" height="1em" viewBox="0 0 20 25">
        <defs>
            <path id="a" d="M.5.5h4v1h-4z" />
            <path id="c" d="M.5.5h4v1h-4z" />
            <path id="e" d="M.5.5h4v1h-4z" />
            <path id="g" d="M.5.5h4v1h-4z" />
            <path id="i" d="M.5.5h4v1h-4z" />
        </defs>
        <g className={className}>
            <g transform="rotate(90 5.5 5.5)">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    d="M4.195.5H.805C.637.5.5.724.5 1s.137.5.305.5h3.39c.168 0 .305-.224.305-.5S4.363.5 4.195.5"
                    mask="url(#b)"
                />
            </g>
            <g transform="rotate(117 7.79 6.102)">
                <mask id="d" fill="#fff">
                    <use xlinkHref="#c" />
                </mask>
                <path
                    d="M4.195.5H.805C.637.5.5.724.5 1s.137.5.305.5h3.39c.168 0 .305-.224.305-.5S4.363.5 4.195.5"
                    mask="url(#d)"
                />
            </g>
            <g transform="rotate(62 1.77 4.782)">
                <mask id="f" fill="#fff">
                    <use xlinkHref="#e" />
                </mask>
                <path
                    d="M4.195.5H.805C.637.5.5.724.5 1s.137.5.305.5h3.39c.168 0 .305-.224.305-.5S4.363.5 4.195.5"
                    mask="url(#f)"
                />
            </g>
            <g transform="rotate(34 -7.313 4)">
                <mask id="h" fill="#fff">
                    <use xlinkHref="#g" />
                </mask>
                <path
                    d="M4.195.5H.805C.637.5.5.724.5 1s.137.5.305.5h3.39c.168 0 .305-.224.305-.5S4.363.5 4.195.5"
                    mask="url(#h)"
                />
            </g>
            <g transform="rotate(150 9.196 6.01)">
                <mask id="j" fill="#fff">
                    <use xlinkHref="#i" />
                </mask>
                <path
                    d="M4.195.5H.805C.637.5.5.724.5 1s.137.5.305.5h3.39c.168 0 .305-.224.305-.5S4.363.5 4.195.5"
                    mask="url(#j)"
                />
            </g>
            <path d="M5.166 12.26c0-2.638 2.142-4.784 4.774-4.784a4.785 4.785 0 0 1 4.775 4.784v6.718h-9.55V12.26zM16.58 23.49a.325.325 0 0 1-.324.325H3.624a.325.325 0 0 1-.324-.325v-2.272a1.19 1.19 0 0 1 1.153-1.187c.012-.001.024-.004.036-.004h10.902c.013 0 .024.003.037.004a1.19 1.19 0 0 1 1.152 1.187v2.272zm-.819-4.478V12.26c0-3.216-2.611-5.833-5.821-5.833-3.21 0-5.82 2.617-5.82 5.833v6.752a2.24 2.24 0 0 0-1.866 2.206v2.272c0 .757.615 1.373 1.37 1.373h12.632c.756 0 1.37-.616 1.37-1.373v-2.272a2.24 2.24 0 0 0-1.865-2.206z" />
            <path d="M9.536 8.52a4.849 4.849 0 0 0-3.411 4.65.524.524 0 1 0 1.046 0 3.806 3.806 0 0 1 2.677-3.65.524.524 0 0 0-.312-1M6.648 14.626a.524.524 0 0 0-.523.524v1.621a.524.524 0 1 0 1.046 0v-1.62a.524.524 0 0 0-.523-.525" />
        </g>
    </svg>
);

export default NoticeAlert;
